import { EntryRegistrationActionType } from "../../types/entryRegistrationType";

export const changeValueEntry = () => {
    return {type: EntryRegistrationActionType.SET_UP_ENTRY}
}

export const changeValueRegistration = () => {
    return {type: EntryRegistrationActionType.SET_UP_REGISTRATION}
}